import React from 'react';
import {
  Typography, Container, Grid, Card, CardMedia, CardContent, CardActions, Button, Box, 
} from '@mui/material';
import './Pricing.css';
 
const Hectorimg ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fmgi-hector-model-car.png?alt=media&token=2a8c4677-56b2-46fd-963d-2041f6019fd0"
const HectorPrice ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/PRICE%2FPrice%20List%20Hector.pdf?alt=media&token=d1d6ee91-e988-43f0-b337-33f855bf6359"
const Astorimg ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/PRICE%2FAstorcard2.webp?alt=media&token=7010df1a-d6ae-40eb-befa-f6640dffcee3"
const AstorPrice ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/PRICE%2FPrice%20List%20Astor.pdf?alt=media&token=1c22a94e-8951-47db-a4fd-a89cd23f9f13"
const Zsimg ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/PRICE%2Fzscard3.webp?alt=media&token=4729007c-d14f-4e9a-9375-e85d0422c334"
const ZsPrice="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/PRICE%2FPrice%20List%20ZS%20EV.pdf?alt=media&token=e3978ba9-a2ec-4bf1-9dc7-4d620d321b63"
const Cometimg ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/PRICE%2FCometcard4.jpg?alt=media&token=155d7d67-f2d3-421f-a58b-2eecf4f35880"
const CometPrice ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/PRICE%2FPrice%20List%20Comet%20EV.pdf?alt=media&token=cd84969e-2cca-45dc-b164-1e43be09a38a"
const Windsorimg ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/PRICE%2Fwindsorcar5.avif?alt=media&token=bda52c55-e6c5-4eca-bde9-b2493239ecca"
const WindsorPrice ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/PRICE%2FPrice%20List%20Windsor%20EV.pdf?alt=media&token=690828e6-08cc-4e65-8e80-dba4ed1d1a02"
const Glosterimg ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/PRICE%2Fglostercard6.avif?alt=media&token=ba045398-0fb4-4e2c-86af-10c20f2793d4"
const cars = [
  {
    id: 1,
    name: "MG HECTOR",
    image: Hectorimg,
    pdf: HectorPrice,
  },
  {
    id: 2,
    name: "MG ASTOR",
    image: Astorimg,
    pdf: AstorPrice,
  },
  {
    id: 3,
    name: "MG ZS EV",
    image: Zsimg,
    pdf: ZsPrice ,
  },
  {
    id: 4,
    name: "MG COMET EV",
    image: Cometimg,
    pdf: CometPrice,
  },
  {
    id: 5,
    name: "MG WINDSOR EV",
    image: Windsorimg,
    pdf: WindsorPrice,
  },
  {
    id: 6,
    name: "MG Gloster",
    image: Glosterimg,
    
  },
];

const PricePage = () => {
  return (
    <div style={{ marginTop: '30px',backgroundColor:'black', }}>
        <div id="banner-image-price">
        </div>
      {/* Car Price List */}
      <Container >
        <Grid container spacing={3}>
          {cars.map((car) => (
            <Grid item xs={12} sm={6} md={4} key={car.id}>
              <Card sx={{marginBottom:'20px'}}>
                <CardMedia
                  component="img"
                  height="200"
                  image={car.image}
                  alt={car.name}
                />
                <CardContent>
                  <Typography variant="h6" sx={{fontWeight:'bolder',textAlign:'center'}}>{car.name}</Typography>
                </CardContent>
                <CardActions>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    fullWidth 
                    onClick={() => window.open(car.pdf, "_blank")}
                    sx={{backgroundColor:'#C62828',fontWeight:'900'}}
                  >
                    Price
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
};

export default PricePage;